import React from 'react';
import { cn } from '../../utils/cn';
export function AspectRatio({ aspectRatio, className, children, ...extra }) {
    const activate = !!aspectRatio;
    return (React.createElement("div", Object.assign({ className: cn(className, activate ? 'relative h-0' : 'h-full w-full'), style: {
            paddingTop: activate ? `${(aspectRatio * 100).toFixed(2)}%` : undefined,
        } }, extra),
        React.createElement("div", { className: cn(activate ? 'absolute-full' : 'h-full w-full') }, children)));
}
